import { render, staticRenderFns } from "./qulaAcquisition.vue?vue&type=template&id=4ef54bdc&scoped=true&"
import script from "./qulaAcquisition.vue?vue&type=script&lang=js&"
export * from "./qulaAcquisition.vue?vue&type=script&lang=js&"
import style0 from "./qulaAcquisition.vue?vue&type=style&index=0&id=4ef54bdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef54bdc",
  null
  
)

export default component.exports